var map = {
	"./gmail-sm.mp4": 8003,
	"./gmail.mp4": 9580,
	"./leisure-sm.mp4": 9454,
	"./leisure.mp4": 7187,
	"./office-sm.mp4": 6679,
	"./office.mp4": 3480,
	"./shortcuts-sm.mp4": 5890,
	"./shortcuts.mp4": 639
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3783;